import "../../scss/pages/support-server.scss";
import TomSelect from "tom-select/dist/js/tom-select.complete.min";
import Form from "../../js/components/form.js";
import ValidationInput from "../helpers/validationInput";

document.addEventListener("DOMContentLoaded", function () {
	
	const formModule = new Form();
	
	formModule.validationForm('#supportServerForm');
	
	new TomSelect("#serverTypeSelect", {
		create: false,
		allowEmptyOption: true,
		maxOptions: null,
		hideSelected: true,
		controlInput: null,
		render: {
			item: function (item, escape) {
				return '<div>' +
					'<span class="name style-selected-item" aria-label="' + escape(item.text) + '">' + escape(item.text) + '</span>' +
					'</div>';
			},
			option: function (item, escape) {
				return '<div>' +
					'<span class="name style-selected-option"  aria-label="' + escape(item.text) + '">' + escape(item.text) + '</span>' +
					'</div>';
			}
		},
		onBlur: function () {
			const form = document.querySelector("#supportServerForm");
			const inputSelect = document.querySelector('#serverTypeSelect');
			ValidationInput.validateInput(inputSelect, form.id);
		}
	});
	
	const rateInputList = document.querySelectorAll(".floatNumber");
	rateInputList.forEach(function (rateInput) {
		const inputElement = rateInput.querySelector('input');
		
		inputElement.addEventListener('input', (event) => {
			
			limitRate(event.target);
		});
	});
	
	function limitRate(inputElement) {
		let prev = inputElement.getAttribute("data-prev");
		prev = prev && prev.length !== 0 ? prev : '';
		if (((Math.round(inputElement.value * 100) / 100) !== Number(inputElement.value))) {
			inputElement.value = prev;
		} else if (inputElement.value < 0) {
			inputElement.value = 0;
		}
		
		inputElement.setAttribute("data-prev", inputElement.value);
	}
	
	formModule.submitForm('#supportServerForm', 'contact/submit-contact-form', '#loaderSupportServerForm', 'hostServer', null, true, true, false, true);
	
});